const add0 = (t) => (String(t).padStart(2, '0'));

export function monthIsSupported() {
  const test = document.createElement('input');
  try {
    test.type = 'month';
  } catch (e) {
    // month is not supported: skip
  }

  return test.type === 'month';
}

/**
 * @param {Date} date
 * @return string
 */
export function formatDateToIsoDateString(date) {
  return `${date.getFullYear()}-${add0(date.getMonth() + 1)}-${add0(date.getDate())}`;
}

/**
 * @param {string} isoDateString
 * @return {Date}
 */
export function dateFromIso(isoDateString) {
  const parts = isoDateString.match(/\d+/g);

  return new Date(parts[0], parts[1] - 1, parts[2]);
}
